import { OptionsObject } from "notistack";

export const success: OptionsObject = { variant: "success" };
export const warning: OptionsObject = { variant: "warning" };
export const error: OptionsObject = { variant: "error" };
export const info: OptionsObject = { variant: "info" };
